import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22NextFontSlot.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./../../../../../public/fonts/woff2/Cera_Pro_Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}]}],%22variableName%22:%22ceraPro%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ceraPro', 'ceraPro Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
